export default Object.freeze({
  siteName: 'BDC|eAkademie',
  colorAccent: "#0a285f", // bdc-blue
  colorHighlight: "#75B7AC", // bdc-green
  privacyLink: "/inhalte/datenschutz#hmcl",
})
